export const broadcastInformation = (state) =>
  state.diagnostics.broadcastInformation;
export const documentDiagnositcs = (state) =>
  state.diagnostics.documentDiagnositcs;
